import { Button, Group, Modal, Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { queryClient } from "~/backend/queryClient"
import { CopyToClipboard } from "~/components/CopyToClipboard"
import {
  findCertificateRequestsForSupplierQueryKey,
  FindCertificateRequestsForSupplierResponseDto,
  useDeleteCertificateRequest,
} from "~/gen/api"
import { useAuth } from "~/store/auth-context"

interface Props {
  certificateRequest: FindCertificateRequestsForSupplierResponseDto
  opened: boolean
  close: () => void
}

export const DeleteCertificateRequestModal = ({
  certificateRequest,
  opened,
  close,
}: Props) => {
  const displayedCertificateRequest = certificateRequest
  const { mutate } = useDeleteCertificateRequest({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [findCertificateRequestsForSupplierQueryKey],
        })
        close()
      },
    },
  })
  const { isAdmin } = useAuth()
  const { t } = useTranslation("traceability")

  const certificateRequestIds = [
    certificateRequest.id,
    ...certificateRequest.aggregatedIds,
  ]

  return (
    <Modal
      opened={opened}
      onClose={close}
      title={
        <Text style={{ textAlign: "center" }}>
          {t("certificates.modal.areyousure")}
        </Text>
      }
    >
      {isAdmin && (
        <Stack>
          <Stack gap="var(--mantine-spacing-xxs)">
            <CopyToClipboard text={displayedCertificateRequest.id} />
            <Text fw={700} style={{ textAlign: "center" }}>
              {displayedCertificateRequest.type.name}{" "}
            </Text>
            <Text style={{ textAlign: "center" }}>
              {displayedCertificateRequest.productionSite?.name}
            </Text>
          </Stack>
          <Group justify="center">
            <Button variant="secondary-critical" onClick={close}>
              {t("certificates.modal.no")}
            </Button>
            <Button
              color="violet"
              variant="secondary"
              onClick={() => {
                certificateRequestIds.forEach((id) => {
                  mutate({
                    data: {
                      certificateRequestId: id,
                    },
                  })
                })
              }}
            >
              {t("certificates.modal.yes")}
            </Button>
          </Group>
        </Stack>
      )}
    </Modal>
  )
}
